import { Modal, Typography } from 'antd';

const { Title, Paragraph } = Typography;

export default function ModalInfoPage({open, setOpen}) {
    
  return (
    <Modal
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
      centered
      width={600}
      bodyStyle={{
        maxHeight: '60vh',
        overflowY: 'auto',
        borderRadius: '12px',
        padding: '24px',
        backgroundColor: '#F3F2F7',
      }}
      style={{
        borderRadius: 16,
      }}
      title={
        <Title level={4} style={{ textAlign: 'center', marginBottom: "10px" }}>
          ပါဝင်ကစားရန် လမ်းညွှန်ချက်များ
        </Title>
      }
    >
      <Paragraph className='pb-2'>
        ခေတ်မှီ စက်ပစ္စည်းများကို ယှဉ်ပြိုင်ဝယ်ယူရန် ShweDeal ဝန်ဆောင်မှုအတွက်စာရင်းသွင်းပြီး ပက်ကေ့ချ် ဝယ်ယူထားဖို့လိုအပ်ပါတယ်။
      </Paragraph>
      <Paragraph className='pb-2'>
        တစ်ကြိမ်သုံး ပက်ကေ့ခ်ျကို ဝယ်ယူရန် စာရင်းသွင်း ပက်ကေ့ဂျ်တစ်ခုကို ဦးစွာ စာရင်းသွင်းရန် လိုအပ်ပါသည်။
      </Paragraph>
      <Paragraph className='pb-2'>
        အပိုပက်ကေ့ချ်များကို ဝယ်ယူရန် နည်းလမ်း ၃ ခုရှိသည်။
      </Paragraph>
      <Paragraph className='pb-2'>
        - ဝဘ်ဆိုဒ် (သို့မဟုတ်) MyIDထဲမှတဆင့် ဝယ်ယူနည်း။ <br />
        ဝဘ်ဆိုဒ် (reverseauction.com.mm) သို့သွားခြင်း သို့မဟုတ် MyID app ရှိ ShweDeal သို့ဝင်ရောက်ပြီး ဤညွှန်ကြားချက်များကို လိုက်နာခြင်းဖြင့် သင်ဝယ်ယူနိုင်ပါသည်။ ပထမအဆင့်အဖြစ် အရင်ဆုံး မှတ်ပုံတင်ခြင်း သို့ login အကောင့်ဝင်ရောက်ပေးရပါမယ်။ ထို့နောက် “ TURN” and “ Turns များဝယ်ယူခြင်း” ကိုနှိပ်ပါ။ ထိုအခါ ဝယ်ယူနိုင်သော ပက်ကေ့ချ်ပမာဏ အမျိုးမျိုးကို တွေ့မြင်နိုင်မှာဖြစ်ပါတယ်။ မိမိနှစ်သက်ရာပမာဏကိုရွေးချယ်၍ ပက်ကေ့ချ်များ ဝယ်ယူနိုင်ပါတယ်။ နောက်တစ်ဆင့်တွင် ဝယ်ယူထားသော လေလံကြေးများလက်ခံရရှိမှာဖြစ်ပြီး စတင်ပါဝင်ကစားနိုင်မှာဖြစ်ပါတယ်။
      </Paragraph>
      <Paragraph className='pb-2'>
        - SMS ဖြင့်ဝယ်ယူနည်း :<br />

        + 1 Turn ရယူရန် 'S1'<br />
        + 2 Turns ရယူရန် 'S2'<br />
        + 5 Turns ရယူရန် 'S5'<br />
        + 10 Turns ရယူရန် 'S10'<br />
        + 20 Turns ရယူရန် 'S20'<br />
        + နေ့စဉ်ပက်ကေ့ချ်(တစ်ရက်စာ 2Turns)ကိုရယူရန် ON1<br />
        + အပတ်စဉ်ပက်ကေ့ချ် (တစ်ပတ်စာ 10Turns)ကို ရယူရန် ON7<br />
        + လစဉ်ပက်ကေ့ချ် (တစ်လစာ 30Turns) ကိုရယူရန် ON30<br />
        စသည့်ဖြင့် 527 သို့ မက်ဆေ့ချ်ပို့ကာ ရယူနိုင်ပါတယ်။<br />
        + စာရင်းသွင်းမှုကို ရပ်ဆိုင်းရန် 527 သို့ OFF ပေးပို့ပါ။
      </Paragraph>
      <Paragraph className='pb-2'>
        - *527# ကိုခေါ်ဆို၍ ဝယ်ယူနည်း။<br />
        သင့်ဖုန်းမှ *527# ကိုခေါ်ဆိုခြင်းဖြင့် Turn ပက်ကေ့ချ် များကိုလည်း ဝယ်ယူနိုင်ပါသည်။ ခေါ်ဆိုပြီးနောက်တွင် နေ့စဉ်၊ အပတ်စဉ်နှင့် လစဉ်စာရင်းသွင်းမှုပက်ကေ့ချ်များ၊ တစ်ကြိမ် Turn ပက်ကေ့်ချ်များ၊ စာရင်းသွင်းမှုမှ ပယ်ဖျက်ခြင်းနှင့် ဝန်ဆောင်မှုအချက်အလက်များကဲ့သို့ မတူညီသောရွေးချယ်စရာများပါရှိသည့် မီနူးတစ်ခုပေါ်လာပါမည်။ အလိုရှိသော ပက်ကေ့ချ်ကို ရွေးချယ်ပြီး ဝယ်ယူမှုကို အပြီးသတ်ရန် လမ်းညွှန်ချက်များအတိုင်း လုပ်ဆောင်နိုင်ပါသည်။ ဤနည်းလမ်းသည် မြန်ဆန်၊ ရိုးရှင်းပြီး အင်တာနက်ချိတ်ပင် မလိုအပ်ပါ။
      </Paragraph>
      <Paragraph className='pb-2'>
      - ခေတ်မှီ စက်ပစ္စည်းများကို ယှဉ်ပြိုင်ဝယ်ယူခြင်းကို သတ်မှတ်ထားသော (နေ့ရက်) အတွင်း ပါဝင်ပေးရမှာဖြစ်ပါတယ်။<br />
      - ပွဲတွင်ပါဝင်ရန် (reverseauction.com.mm)website သို့ သွားရောက်ပေးပါ။ ပထမဆုံး အကောင့် login ဝင်ပေးပါ။ ပြီးလျှင် အနိမ့်ဆုံးနှင့်အထူးခြားဆုံး ပမာဏကိုရေးပြီး 'လေလံဆွဲမည်' ’ယှဉ်ပြိုင်ဝယ်ယူမည်’ ကို နှိပ်လိုက်ပါ။<br />
      - အနည်းဆုံးကြေးမှာ မြန်မာကျပ် ၁၀၀၀ ကျပ်ဖြစ်ပြီး တစ်ကြိမ်လျှင် ၅၀ ကျပ်စီတိုး၍ ပါဝင်ကစားနိုင်ပါတယ်။ အသုံးပြုသောငွေကြေး (မြန်မာကျပ်ငွေ)မှာ ဂိမ်းထဲတွင်သုံးသော ရည်ညွှန်းပမာဏမျှသာဖြစ်ပါတယ်။ တကယ့်ငွေကြေး မဟုတ်ပါ။<br />
      - ပါဝင်ရာ၌ တစ်ကြိမ်လျှင် အများဆုံး 1 digit နှင့် ၅၀ကျပ်စီသာတိုးနိုင်ပါတယ်။ ဥပမာ - ၁၀၀၀ ကျပ် (သို့) ၁၀၅၀ ကျပ် (သို့) ၁၁၀၀ ကျပ် စသဖြင့် ပါဝင်နိုင်ပါတယ်။ ၁၁၃၀ ကျပ်ကိုတော့ ကြေးအဖြစ်တင်၍ မရပါ။<br />
      - ကြေးသည် ကြိုတင်သတ်မှတ်ထားခြင်းမရှိပါ။ အရင်လေလံဆွဲခဲ့သော ကြေးသတ်မှတ်ချက်များအတွင်း အကျုံးဝင်သ၍ ပွဲတွင်ပါဝင်သူများသည် ကိုယ့်စိတ်ကြိုက်သတ်မှတ်ထားသော ကြေးပမာဏဖြင့် ပါဝင်ကစားနိုင်ပါတယ်။ <br />
      - ပြီးပါက မိမိ ပါဝင်ကစားထားသောပမာဏသည် အနိမ့်ဆုံးနှင့်တစ်ခုတည်းသောကြေးဖြစ်သည် (သို့ ) အနိမ့်ဆုံးနှင့်တစ်ခုတည်းသောကြေးမဟုတ်ပါ စသဖြင့် အကြောင်းကြားပေးသော SMS မက်ဆေ့ချ်ကို လက်ခံရရှိမှာဖြစ်ပါတယ် ။<br />
      </Paragraph>
    </Modal>
  );
}
